import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=2106252b&scoped=true"
var script = {}
import style0 from "./Flag.vue?vue&type=style&index=0&id=2106252b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106252b",
  null
  
)

export default component.exports